import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../environments/environment";
import * as HSET from "./settings";
import { GenericHttpService } from "../../../services/generic-http.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class DataService {

  apiUrl = environment.gateWayHost;
  widgetId: any;
  constructor(public generic: GenericHttpService) { }

  getData(url, params, widgetData): Observable<any> {
    const option = {
      method: "GET",
      url: `${this.apiUrl}${url}`, // "./assets/data/p-d-reason.json",
      query: params
    };
    try {
      const functionToCall = this.returnFunctionToCall(widgetData);
      return this.generic.httpRequest(option).pipe(
        catchError(this.generic.handleError),
        map(functionToCall)
      );
    }
    catch (error) {
      if (error.message === 'argument is not a function. Are you looking for `mapTo()`?')
        console.log(`There is no data handler for this widget id: ${widgetData.id}`);
    }
  }

  returnFunctionToCall(widgetData) {
    this.widgetId = Number(widgetData.id)
    if (Number(widgetData.id) === 3) {
      return this.processDataOTIFDelivery;
    }
    if (Number(widgetData.id) === 13) {
      return this.processDataOTIFInward;
    }
    if (Number(widgetData.id) === 17) {
      return this.processDataOTIFReturn;
    }
    if (Number(widgetData.id) === 9) {
      return this.processDataOTIFTransfer;
    }
    if (Number(widgetData.id) === 34) {
      return this.processCumulativeStatus;
    }
  }
  processDataOTIFDelivery(data: any) {
    if (data.data.length === 0) return null;
    let total = data.data.reduce((sum, obj) => {
      return sum + obj.failure;
    }, 0);
    total = Number(total);
    const series = data.data.map(obj => [
      obj.failure_reason.charAt(0).toUpperCase() + obj.failure_reason.slice(1),
      Number(obj.quantity.toFixed(0))
    ]);
    total = total.toFixed(0);
    return { series, total };
  }

  processDataOTIFInward(data: any) {
    if (data.data.length === 0) return null;
    const total = data.data.reduce((sum, obj) => {
      return sum + obj.failure;
    }, 0);
    const series = data.data.map(obj => [
      obj.failure_reason.charAt(0).toUpperCase() + obj.failure_reason.slice(1),
      Number(obj.quantity.toFixed(2))
    ]);

    return { series, total };
  }

  processDataOTIFReturn(data: any) {
    if (data.data.length === 0) return null;
    const total = data.data.reduce((sum, obj) => {
      return sum + obj.failure;
    }, 0);
    const series = data.data.map(obj => [
      obj.failure_reason.charAt(0).toUpperCase() + obj.failure_reason.slice(1),
      Number(obj.quantity.toFixed(2))
    ]);

    return { series, total };
  }
  processDataOTIFTransfer(data: any) {
    if (data.data.length === 0) return null;
    const total = data.data.reduce((sum, obj) => {
      return sum + obj.failure;
    }, 0);
    const series = data.data.map(obj => [
      obj.failure_reason.charAt(0).toUpperCase() + obj.failure_reason.slice(1),
      Number(obj.quantity.toFixed(2))
    ]);

    return { series, total };
  }

  processCumulativeStatus(data: any) {
    if (data.data.length === 0) return null;
    const seriesName = {
      'invoiced': "Ready to Dispatch",
      "delivered": "Delivered",
      "in_transit": "In-transit",
      "cancelled": "Cancelled",
      "to_be_invoiced": "To be Invoiced"
    };
    let total = 0;
    let keyName;
    const series = [];
    for (keyName in data.data) {
      if (seriesName[keyName]) {
        series.push([seriesName[keyName], data.data[keyName]]);
        total += data.data[keyName];
      }
    }
    return { series, total };
  }

  createChart(chartData, CHARTCONFIG) {

    const chart = JSON.parse(JSON.stringify(HSET.chartData));
    chart.series[0].data = chartData.series;

    if (CHARTCONFIG.title) {
      chart.title.text = `<div style = "text-align:center;">
      <strong style = "font-size:30px">${chartData.total}</strong>
      <br/>${CHARTCONFIG.title.text}</div>`;
      chart.title.y = this.widgetId === 34 ? -30 : -10;
    }

    if (CHARTCONFIG.xAxis) {
      // do nothing cause the data comes entirely from bckend, including the labels
    }

    if (CHARTCONFIG.yAxis) {
      // do nothing cause there is nothing to do (no yAxis in Pie chart- well there is no xAxis either, 
      // but we can keep this for consistency across all charts)
    }

    if (CHARTCONFIG.legend) {

      // checks on each property means - if the user hasn't input anything, use the default
      if (CHARTCONFIG.legend.colorSet.length) {
        chart.plotOptions.pie.colors = CHARTCONFIG.legend.colorSet;
      }

      if (CHARTCONFIG.legend.fontColor) {
        chart.legend.itemStyle.color = CHARTCONFIG.legend.fontColor;
      }

      if (CHARTCONFIG.legend.fontWeight) {
        chart.legend.itemStyle["font-weight"] = CHARTCONFIG.legend.fontWeight;
      }
    }



    return chart;
  }
}
